var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center justify-center rounded-full fixed bg-costeaPrimary w-16 h-16 transition duration-300 ease-in-out hover:bg-costeaHover right-6 bottom-10 z-30",on:{"click":function($event){return _vm.toggleModal()}}},[_c('i',{staticClass:"ri-add-fill text-5xl m-2 text-white"})])
}
var staticRenderFns = []

export { render, staticRenderFns }